var params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
var tests = [{name: "TrueRandTest", "segments": [{name: "TRT_control", weight: 50, componentFunc: null}, 
                                                 {name: "TRT_variant", weight: 50, componentFunc: null}]},
             {name: "NewHeroSept26", "segments": [{name: "NHSept26_control", weight: 50, componentFunc: null}, 
                                               {name: "NHSept26_v1", weight: 50, componentFunc: null}]},                                  
             {name: "CircleVideoUnit", "segments": [{name: "CVU_v1", weight: 50, componentFunc: null}, 
                                                    {name: "CVU_control", weight: 50, componentFunc: null}]}
             ];

var hensonPrefix = "henson_cro_";

function RollTests() {
  tests.forEach(processTest);
}

function processTest(test) {     
  var segment = null;

  if (segment == null && params[test.name] != null) {
    segment = findSegment(test.segments, params[test.name]);
  }
  if (segment == null && params["reroll"] == null && localStorage.getItem(getStorageName(test.name)) != null) {
    segment = findSegment(test.segments, localStorage.getItem(getStorageName(test.name)));
  }
  if (segment == null) {
    let totalWeight = 0;
    for (var i = 0; i < test.segments.length; i++) {
      totalWeight += test.segments[i].weight;
    }
    
    // Only roll if there's weight to distribute
    if (totalWeight > 0) {
        const value = Math.floor(Math.random() * totalWeight) + 1;
        let cumulativeWeight = 0;
        for (var i = 0; i < test.segments.length; i++) {
          cumulativeWeight += test.segments[i].weight;
          if (cumulativeWeight >= value) {
            segment = test.segments[i];
            break;
          }
        }
    }
  }

  // Only proceed if a segment was successfully chosen
  if (segment) {
    localStorage.setItem(getStorageName(test.name), segment.name);
    gtag('event', 'cro', {'event_category': test.name, 'event_label': segment.name, 'non_interaction': true});
    gtag('set', 'cro_dimension1', test.name + "_" + segment.name);
  
    if (window.TriplePixel) {
      TriplePixel('custom', 'cro', {'test_name': test.name, 'segment': segment.name});
    }
    
    if (segment.componentFunc) {
      segment.componentFunc();
    }
  }
}

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function showNHSept26() {
  // Find the title and subtitle elements by their IDs.
  const titleElement = document.querySelector('#nhsept26title');
  const subtitleElement = document.querySelector('#nhsept26subtitle');

  // Only proceed if both elements are found on the page.
  if (titleElement && subtitleElement) {
    // Change the text content of the title element.
    titleElement.innerText = 'Noticeably Better.';
    
    // Change the text content of the subtitle element.
    subtitleElement.innerText = 'We believed a rigidly clamped, precisely held blade would deliver a better shave with less irritation, and both clinical studies and customer feedback confirm Henson leaves your skin noticeably better.';
  }
}

function showCVU () {
  var insertCVU = document.querySelector('#circular-video-unit-cvu');
  if (insertCVU) {
const html = `
   <div id="lightbox-cvu">
    <div class="lightbox-cvu-content">
      <span id="close-lightbox-cvu">&times;</span>
      <video id="video-cvu" class="video-cvu" autoplay playsinline muted loop>
        <!-- Video source will be dynamically set by JavaScript -->
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
  <div class="grid-container-cvu">
    <div class="video-tile-cvu" data-video-url="https://cdn.shopify.com/videos/c/o/v/2494be026ccc4bd0a88982b9815bb9c9.mp4">
      <video class="thumbnail-cvu" playsinline autoplay muted loop>
      <source src="//cdn.shopify.com/videos/c/o/v/e8af3e173f014e0c90b932565a2548f1.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    </div>
    <div class="video-tile-cvu" data-video-url="//cdn.shopify.com/videos/c/o/v/1cc32ec9efa6430797d8f6307584a6bb.mp4">
      <video class="thumbnail-cvu" playsinline autoplay muted loop>
      <source src="//cdn.shopify.com/videos/c/o/v/017fb9ea71e44c0e99d917b002b9421a.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    </div>
    <div class="video-tile-cvu" data-video-url="//cdn.shopify.com/videos/c/o/v/5558639b193f4786b714e4c37416ca18.mp4">
      <video class="thumbnail-cvu" playsinline autoplay muted loop>
      <source src="//cdn.shopify.com/videos/c/o/v/1f7ffd8d1bbe44c0a069111778377382.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    </div>
    <div class="video-tile-cvu" data-video-url="//cdn.shopify.com/videos/c/o/v/443905e05b2b46f7be80e425a0408307.mp4">
      <video class="thumbnail-cvu" playsinline autoplay muted loop>
      <source src="//cdn.shopify.com/videos/c/o/v/cd3e1e30f9cc4f33bad1c3eee00a9394.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    </div>
  </div>
  
<style>
#lightbox-cvu {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease;
}

#lightbox-cvu.visible {
  visibility: visible;
  opacity: 1;
}
    
body.lightbox-open {
  overflow: hidden;
}

.lightbox-cvu-content {
--r: 9 / 16;
    aspect-ratio: var(--r);
    width: min(75%, min(500px, 75vh*(var(--r))));
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

#video-cvu {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 75vh; /* 75% of viewport height */
}
  
#close-lightbox-cvu {
  position: absolute;
  bottom: -30px;
  right: -30px;
  color: #fff;
  font-size: 40px;
  cursor: pointer;
  }
.grid-container-cvu {
  justify-items: center;
  max-width: 800px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns */
  gap: 5px; /* Gap between videos */
  padding-top: 20px;
}

.video-tile-cvu:hover {
  cursor: pointer;
}
    
/* Style for each video tile */
.video-tile-cvuasdf {
  border-radius: 50%; /* Change to 50% for a circle */
  overflow: hidden;
  display: flex; /* Add flex display */
  justify-content: center; /* Center the image horizontally */
  align-items: center; /* Center the image vertically */
  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 5px #657994;
  max-height: 100px;
  max-width: 100px;
}
    
/* Style for each video tile */
.video-tile-cvu {
  border-radius: 50%; /* Change to 50% for a circle */
  overflow: hidden;
  background-color: #f0f0f0; /* Background color for tiles */
  display: flex; /* Add flex display */
  justify-content: center; /* Center the image horizontally */
  align-items: center; /* Center the image vertically */
  border: double 7px white;
  background-image: linear-gradient(white, white),
  linear-gradient(90deg, #833ab4, #fd1d1d, #fcb045);
  background-origin: border-box;
  background-clip: content-box, border-box;
  max-height: 100px;
  max-width: 100px;
}
    
.thumbnail-cvu {
  border-radius: inherit;
  display: block;
  width: 100%;
  height: auto;
}

.faq-titlezz {
  text-align: center;
  font-weight: 500;
  font-size: 24px;
  padding: 20px;
  font-family: poppins;
}
    
@media (min-width: 1150px) {
.grid-container-cvu {
  gap: 15px; /* or any other value you want */
}
}
  </style>
`;

const script = document.createElement('script');
script.textContent = `
  document.querySelectorAll('.grid-container-cvu div').forEach(item => {
    item.addEventListener('click', () => {
      const videoUrl = item.getAttribute('data-video-url');
      document.getElementById('video-cvu').src = videoUrl;
      document.getElementById('lightbox-cvu').classList.add('visible');
      document.body.classList.add('lightbox-open'); // Add class to disable scrolling
    });
  });
  
  document.getElementById('close-lightbox-cvu').addEventListener('click', () => {
    document.getElementById('lightbox-cvu').classList.remove('visible');
    document.getElementById('video-cvu').src = '';
    document.body.classList.remove('lightbox-open'); // Remove class to enable scrolling
  });
  
  document.getElementById('lightbox-cvu').addEventListener('click', (e) => {
    if (e.target.id === 'lightbox-cvu') {
      document.getElementById('lightbox-cvu').classList.remove('visible');
      document.getElementById('video-cvu').src = '';
      document.body.classList.remove('lightbox-open'); // Remove class to enable scrolling
    }
  }); 
`;
document.querySelector('#circular-video-unit-cvu').insertAdjacentHTML('beforeend', html);
document.querySelector('#circular-video-unit-cvu').appendChild(script);
  }
}

function findSegment(segments, name) {
  for (var i = 0; i < segments.length; i++) {
    if (segments[i].name == name) {
      return segments[i];
    }      
  }
  return null;
}

function getStorageName(name) {
  return hensonPrefix + name;
}

// We wait for the HTML document to be fully loaded before running the tests.
// This prevents errors where the script tries to find an element that doesn't exist yet.
document.addEventListener('DOMContentLoaded', function() {
  RollTests();
});

